import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Navigation from './nav';
import Footer from './footer';
import { StickyContactSection, AskMoreFromAdPackagesForm } from './section';
import createTranslate from '../utils/translator-provider';
import { AdPackageProvider } from './ad-packages/useadpackage';

const Layout = ({children, hideDefaultStickyButton=false, showLeftStickyButton=false, leftStickyButtonAsSecondaryButton = false }) => {
  const data = useStaticQuery(graphql`
  query {
    page: contentfulPage(name: { eq: "General layout" }) {
      title
      translations {
        key
        value {
          value
        }
      }
    }
  
    commonMetadata: allContentfulSiteMetadata {
      nodes {
        siteName
        siteBaseUrl
        siteTitlePrefix
        analyticsScriptUrl
        themeColor
        socialMediaImage {
          gatsbyImageData
        }
        facebookAppId
        googleSiteVerification
        openGraphArticleSection
        openGraphType
        twitterCardType
        twitterHandle
      }
    }
  }
  `);

  const translate = createTranslate(data.page.translations);

  return (
    <AdPackageProvider>
      <Navigation />
      {children}
      <Footer />
      {!hideDefaultStickyButton && <StickyContactSection
        openButtonText={translate('site.contactFormContainer.openButton')}
      />}
      {showLeftStickyButton && <StickyContactSection openButtonText={translate(`adPackages.OrderForm.AskMore`)} Form={AskMoreFromAdPackagesForm} leftSide z="1001" isSecondary={leftStickyButtonAsSecondaryButton} />}
    </AdPackageProvider>
  );
};

export default Layout;
